import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useArgomenti from '../../hooks/useArgomenti'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useSelector } from 'react-redux'
import { ROLES } from '../../model/roles'
import CustomModal from '../../components/CustomModal/CustomModal'
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable'
import CustomPagination from '../../components/CustomPagination/CustomPagination'
import CustomTable from '../../components/CustomTable/CustomTable'
import LoadingTable from '../../components/LoadingTable/LoadingTable'
import { ACTION_TYPES } from '../../model/actions'
import UtilityService from '../../services/UtillityServices/UtilityService'
import { alertService } from '../../services/AlertService'
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow'

const ArgomentiPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const isWideScreen = useMediaQuery('(min-width: 1200px)')
  const { loadingStateArgomenti, modalStateArgomenti, setModalStateArgomenti, getArgomentiByParams, createArgomento, updateArgomento, deleteArgomento } = useArgomenti()
  
  const courseData = location.state?.courseData
  const [argomenti, setArgomenti] = useState([])
  const [selectedArgomento, setSelectedArgomento] = useState(null)
  const userLoggedIn = useSelector(state => state?.user?.userData)
  
  const [orderBy, setOrderBy] = useState('titolo')
  const [orderType, setOrderType] = useState('asc')
  const [selectedPage, setSelectedPage] = useState(1)
  const [formDataFilter, setFormDataFilter] = useState({})
  const [totalPages, setTotalPages] = useState(1)
  const [isLoadingArgomenti, setIsLoadingArgomenti] = useState(false)
  
  useEffect(() => {
    if (!courseData?.id_corso) {
      navigate("/gestione-corsi")
      return
    }
    fetchArgomenti()
  }, [courseData, orderBy, orderType, selectedPage])
  
  const fetchArgomenti = async () => {
    setIsLoadingArgomenti(true)
    const obj = {
      filtri: {
        ...formDataFilter,
        id_corso: courseData.id_corso
      },
      limite: 10,
      pagina: selectedPage,
      ordinamento: `${orderBy} ${orderType}`
    }
    
    try {
      const response = await getArgomentiByParams(obj)
      setArgomenti(response.data)
      setTotalPages(Math.ceil(response.count / obj.limite))
    } catch (error) {
      console.error("Errore nel recupero degli argomenti:", error)
    } finally {
      setIsLoadingArgomenti(false)
    }
  }
  
  const onFilteredTable = async () => {
    setSelectedPage(1)
    await fetchArgomenti()
  }
  
  const handleOrder = (newOrderBy, newOrderType) => {
    setOrderBy(newOrderBy)
    setOrderType(newOrderType)
  }
  
  const handlePageChange = (page) => {
    setSelectedPage(page)
  }
  
  const handleCreateArgomento = () => {
    setSelectedArgomento(null)
    setModalStateArgomenti({ ...modalStateArgomenti, showModalCreateArgomento: true })
  }
  
  const handleEditArgomento = (argomento) => {
    setSelectedArgomento(argomento)
    setModalStateArgomenti({ ...modalStateArgomenti, showModalUpdateArgomento: true })
  }

  const handleDeleteArgomento = (argomento) => {
    setSelectedArgomento(argomento)
    setModalStateArgomenti({ ...modalStateArgomenti, showModalDeleteArgomento: true })
  }
  
  const onSaveArgomento = async () => {
    const data = { ...selectedArgomento, id_corso: courseData.id_corso }
    const requiredFields = ["titolo"]
    const missingFields = UtilityService.validationForm(data, requiredFields)
    if (missingFields?.length > 0) {
      alertService.warn(`I seguenti campi sono obbligatori: ${missingFields}`, {autoClose: true})
      return
    }

    if (modalStateArgomenti.showModalCreateArgomento) {
      await createArgomento(data)
    } else if (modalStateArgomenti.showModalUpdateArgomento) {
      await updateArgomento(data)
    }
    fetchArgomenti()
    handleCloseModal()
  }

  const onDeleteArgomento = async () => {
    const data = {id_argomento: selectedArgomento.id_argomento}
    await deleteArgomento(data)
    fetchArgomenti()
    handleCloseModal()
  }
  
  const handleCloseModal = () => {
    setModalStateArgomenti({ 
      showModalCreateArgomento: false, 
      showModalUpdateArgomento: false,
      showModalDeleteArgomento: false
    })
    setSelectedArgomento(null)
  }
  
  const renderArgomentoForm = () => (
    <form>
      <div className="mb-3">
        <label htmlFor="titolo" className="form-label">Titolo</label>
        <input 
          type="text" 
          className="form-control" 
          placeholder='Titolo'
          id="titolo" 
          value={selectedArgomento?.titolo || ''} 
          onChange={(e) => setSelectedArgomento({...selectedArgomento, titolo: e.target.value})}
        />
      </div>
    </form>
  )

  const renderSelectedDeleteArgomento = () => {
    return (
      <>
        <span className="d-block fs-4 mb-2"><b>Vuoi eliminare il seguente argomento?</b> </span>
        <span className="d-block fs-5">{selectedArgomento?.titolo}</span>
      </>
    )
  }
  
  const argomentoColumns = [
    { key: 'titolo', label: 'Titolo' },
  ]
  
  const actions = [
    {
      label: ACTION_TYPES.UPDATE,
      icon: 'bi-pencil-fill text-warning',
      tooltip: ACTION_TYPES.UPDATE,
      type: ACTION_TYPES.MANAGER,
      condition: () => userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.DOCENTE || userLoggedIn?.role === ROLES.COURSE_DESIGNER,
      onClick: (argomento) => handleEditArgomento(argomento)
    },
    {
      label: ACTION_TYPES.DELETE,
      icon: 'bi-trash-fill text-danger',
      tooltip: ACTION_TYPES.DELETE,
      type: ACTION_TYPES.MANAGER,
      condition: () => userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.DOCENTE || userLoggedIn?.role === ROLES.COURSE_DESIGNER,
      onClick: (argomento) => handleDeleteArgomento(argomento)
    }
  ]
  
  return (
    <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
      <div className='container'>
      <ComebackArrow path={"/gestione-corsi"} />
        <div className='d-flex justify-content-between custom-card-header'>
          <div className='d-flex gap-3 custom-card-title my-2'>
          <div className={`custom-icon-container`}>
                    {courseData?.immagine_corso ? 
                     <img src={courseData?.immagine_corso} className='custom-icon' alt='immagine corso'/> : 
                     <i className={`bi custom-icon bi-mortarboard fs-2`}></i>}
                  </div>
            <div className='align-self-center'>
              <span className='fs-4 d-block'><i><b>Argomenti del corso: {courseData?.denominazione}</b></i></span>
            </div>
          </div>
          {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER || userLoggedIn.role === ROLES.DOCENTE) && (
            <div className='align-self-center my-2'>
              <button type='button' className='btn btn-primary' onClick={handleCreateArgomento}>Aggiungi argomento</button>
            </div>
          )}
        </div>
        
        <div className='mt-5'>
          <CustomFilterTable 
            formDataFilter={formDataFilter}
            setFormDataFilter={setFormDataFilter}
            onFilteredTable={onFilteredTable}
            isLoadingData={isLoadingArgomenti}
            searchNodeType={[
              {nodeType: "input", name: "titolo", placeholder: "Titolo"},
            ]}
          />
        </div>

        {isLoadingArgomenti ? (
          <LoadingTable loadingCol={2} />
        ) : (
          <>
            {argomenti?.length === 0 ? (
              <div className='mt-5 pt-5 text-center'>
                <p>Non ci sono argomenti da mostrare.</p>
              </div>
            ) : (
              <>
                <CustomTable
                  data={argomenti}
                  actions={actions}
                  columns={argomentoColumns}
                  handleOrder={handleOrder}
                  orderBy={orderBy}
                  orderType={orderType}
                />
                <div className="d-flex justify-content-end mt-1">
                  <CustomPagination
                    totalPages={totalPages}
                    selectedPage={selectedPage}
                    handlePageChange={handlePageChange}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>

      <CustomModal
        show={modalStateArgomenti.showModalCreateArgomento || modalStateArgomenti.showModalUpdateArgomento}
        onHide={handleCloseModal}
        headerText={modalStateArgomenti.showModalCreateArgomento ? "Crea argomento" : "Modifica argomento"}
        size={"md"}
        btnText={"Salva"}
        body={renderArgomentoForm()}
        onSave={onSaveArgomento}
        isLoading={loadingStateArgomenti.isLoadingArgomentoCreating || loadingStateArgomenti.isLoadingArgomentoUpdate}
        closeButton={true}
        onUndoChanges={handleCloseModal}
      />

      <CustomModal
        show={modalStateArgomenti.showModalDeleteArgomento}
        onHide={handleCloseModal}
        headerText="Elimina argomento"
        size={"md"}
        variant={"danger"}
        btnText={"Elimina"}
        body={renderSelectedDeleteArgomento()} 
        isLoading={loadingStateArgomenti.isLoadingArgomentoDelete}
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onDeleteArgomento} 
      />
    </div>
  )
}

export default ArgomentiPage